import { ColumnName, ColumnRank, ColumnNoc, ColumnHorse, ColumnAthleteHorse, ColumnStartOrder, ColumnExpander, ColumnQualification, ColumnStartTime, ColumnResult} from "components/common/TableColumns"
import { ColumnTeamMember } from "../common/TableColumns";

export function DressageGroupColumns() {
    return [
        ColumnRank({hasRankEqual:true}),
        ColumnStartOrder({}),
        ColumnStartTime({label:'HeaderStarts',  className: 'text-end', headerClassName:'text-end w-5'}),
        ColumnNoc({}),
        ColumnName({headerClassName:'text-start w-30 align-middle'}),
        ColumnAthleteHorse({}),
        ColumnTeamMember({}),
        ColumnHorse({headerClassName: 'text-start w-30', disableSort:true}),
        ColumnResult({label:'HeaderTotPercentScore', headerClassName:'text-end w-10 mirs-break-line'}),
        ColumnQualification({className: 'text-end fw-bold'}),
        ColumnExpander({})
    ];
}

export function DressageGroupTeamColumns() {
    return [
        ColumnRank({hasRankEqual:true}),
        ColumnStartOrder({}),
        ColumnNoc({}),
        ColumnName({headerClassName:'text-start align-middle'}),
        ColumnResult({label:'HeaderTotPercentScore', headerClassName:'text-end w-5 mirs-break-line'}),
        ColumnQualification({className: 'text-end fw-bold'}),
        ColumnExpander({})
    ];
}

